var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-box',[_c('label',{staticClass:"container"},[_vm._v(_vm._s(_vm.title)+" "),_c('input',{attrs:{"type":"checkbox","checked":"checked"}}),_c('span',{staticClass:"checkmark"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }